import { render, staticRenderFns } from "./PatientInfoDetail.vue?vue&type=template&id=ac54d2d2&scoped=true&"
import script from "./PatientInfoDetail.vue?vue&type=script&lang=js&"
export * from "./PatientInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatientInfoDetail.vue?vue&type=style&index=0&id=ac54d2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac54d2d2",
  null
  
)

export default component.exports